// extracted by mini-css-extract-plugin
module.exports = {"root":"X_bY"};